import { LangKey, useTranslation } from "@vixi/localization";
import {
  Stepper,
  StepperIndicator,
  StepperItem,
  StepperNav,
  StepperSeparator,
  StepperTitle,
  StepperTrigger,
} from "../base/stepper";

interface FlowStepperProps {
  activeStep: number;
  steps: LangKey[];
}

const FlowStepper = ({ activeStep, steps }: FlowStepperProps) => {
  const { t } = useTranslation();

  return (
    <div className="mt-8.75 flex grow-1 items-center justify-center">
      <Stepper value={activeStep}>
        <StepperNav>
          {steps.map((label, step) => (
            <StepperItem key={step} step={step} className="relative flex-1 items-start">
              <StepperTrigger className="pointer-events-none flex flex-col gap-2.5">
                <StepperIndicator className="data-[state=active]:bg-primary data-[state=completed]:bg-primary" />
                <StepperTitle className="data-[state=active]:block data-[state=completed]:hidden data-[state=inactive]:hidden">
                  {t(label)}
                </StepperTitle>
              </StepperTrigger>
              {steps.length > step + 1 && (
                <StepperSeparator className="group-data-[state=completed]/step:bg-primary absolute inset-x-0 top-4 z-1 m-0 -translate-y-1/2 group-data-[orientation=horizontal]/stepper-nav:start-[calc(50%+0.875rem)] group-data-[orientation=horizontal]/stepper-nav:w-[calc(100%-2rem+0.225rem)]" />
              )}
            </StepperItem>
          ))}
        </StepperNav>
      </Stepper>
    </div>
  );
};

export { FlowStepper, type FlowStepperProps };
